import ConfigManager from '@/config/ConfigManager.js' 
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators'; 

export default {
    /**
     * @param {StandardRegisterModel} params /module/StandardRegister/model/StandardRegisterModel.js
     */
    apiStandardRegister: function (params, token) {  
        let url = ConfigManager.getApiModuleUrl() + "/tni/front_end_questionnaire_answer";
        return BzbsApi.connectBzbsPostJson(url, token, params).pipe(map((res) => { 
            return res.data;
        }));
    },
    apiMarketingTemplateRegister: function (params, token) {  
        let url = ConfigManager.getApiModuleUrl() + "/tni/front_end_questionnaire_answer_wait";
        return BzbsApi.connectBzbsPostJson(url, token, params).pipe(map((res) => { 
            return res.data;
        }));
    },
}
